import OnboardingIndex from '../OnboardingIndex.vue';
import alert_mixin from '@/utils/mixins/alert_mixin';
import { signup_organization } from '@/services/organization_service.js';

export default {
  name: 'OrganizationSignup',
  mixins: [alert_mixin],
  components: {
    OnboardingIndex
  },
  data: () => ({
      title: 'Create Organization Account',
      submitButtonText: 'Create Account',
      verification_running: false,
      show_password: false,
      form: {
        organization_name: '',
        first_name: '',
        last_name: '',
        email: '',
        password: ''
      }
  }),
  methods: {
    validate_form() {
      const required_fields = [
        'organization_name',
        'first_name',
        'last_name',
        'email',
        'password'
      ];
      const missing = required_fields.some((field) => !String(this.form[field] || '').trim());
      if (missing) {
        this.show_error('Please complete all required fields.');
        return false;
      }
      if (String(this.form.password).length < 8) {
        this.show_error('Password must be at least 8 characters.');
        return false;
      }
      return true;
    },
    async signup_function() {
      if (!this.validate_form()) {
        return;
      }

      this.verification_running = true;
      try {
        const response_data = await signup_organization(this.form);
        if (response_data?.status !== 'success') {
          this.show_error(response_data?.message || 'Could not create organization account.');
          return;
        }

        this.show_success(
          response_data?.message
          || 'Organization account created successfully. Please check the admin email for login credentials.'
        );
        await this.$router.replace({ name: 'UserLogin' });
      } catch (error) {
        const response_data = error?.response?.data;
        this.show_error(
          response_data?.message
          || response_data?.detail
          || 'Unable to create organization account.'
        );
      } finally {
        this.verification_running = false;
      }
    },
    toggle_password_visibility() {
      this.show_password = !this.show_password;
    }
  }
};
